import MinicartBaseContentProvider from './hooks/useMinicartBaseContent';

import { MinicartBaseContentProps } from './@types/MinicartBaseContentProps';

const MinicartBaseContent = (props: MinicartBaseContentProps) => (
	<MinicartBaseContentProvider {...props}></MinicartBaseContentProvider>
);

export default MinicartBaseContent;
